<script>
export default {
    components: {
    },
    

    data() {
        return {
            postedDeals: [],
            isLoading: false,
            availableBalance: 0,
            tracked: 0,
            totalEarned: 0,
            rewardsData: {
                available_funds: 0,
                tracked_funds: 0,
                paid_funds: 0,
                requested_funds: 0,
            },
        };
    },

    async mounted() {
        this.isLoading = true;

        const postedDeals = await window.axios.get('/api/user/earnings');
        this.postedDeals = postedDeals.data;

        const rewardsData = await window.axios.get('/api/user/rewards');
        this.rewardsData = rewardsData.data;

        this.isLoading = false;
    },

    methods: {
        withdraw() {
            Vue.toasted.show(
                `Are you sure you wish to withdraw £${parseFloat(this.rewardsData.available_funds).toFixed(2)} to the paypal address ${this.$store.state.user.profile.paypal_email}?`, 
                { 
                    duration: 6000,
                    action: [
                        {
                            text: 'Confirm',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                                window.axios.post('/api/user/withdraw');
                                setTimeout(function () {
                                    Vue.toasted.show("We've added your withdrawal request to the queue, Payments are generally processed once a day.", {duration: 6000})
                                }, 1000);
                            },
                        },
                    ],
                });
            },
        },
};
</script>


<template lang='pug' src='./template/Withdraw.pug'></template>
<style lang='stylus' src='./styles/Withdraw.styl' scoped></style>

